<template>
    <Form @submit="submit" :validation-schema="getSchema()">
        <div class="flex items-center  xl:flex-row flex-col gap-3 mt-3 mb-3">   
        <div class="w-full xl:w-1/3">
            <div class="input-wrapper">
                <Field v-slot="{field, errors, errorMessage}" name="batch_lot" v-model="form.batch_lot">
                    <label class="text-xs" :class="labelClass(field.value, errorMessage)">Lot #</label>
                    <input v-bind="field" placeholder="12213343432" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="text">
                    <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                    <div v-else class="text-xs">&nbsp;</div>
                </Field>
            </div>
        </div>

        <div class="w-full xl:w-1/3">
            <div class="input-wrapper">
                <Field v-slot="{field, errors, errorMessage}" name="packaged_on" v-model="form.packaged_on">
                    <label class="text-xs" :class="labelClass(field.value, errorMessage)">Packaged On</label>
                    <div class="relative">
                        <span class="absolute top-2 left-2">
                            <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.75 12C9.46667 12 9.22917 11.9042 9.0375 11.7125C8.84583 11.5208 8.75 11.2833 8.75 11C8.75 10.7167 8.84583 10.4792 9.0375 10.2875C9.22917 10.0958 9.46667 10 9.75 10C10.0333 10 10.2708 10.0958 10.4625 10.2875C10.6542 10.4792 10.75 10.7167 10.75 11C10.75 11.2833 10.6542 11.5208 10.4625 11.7125C10.2708 11.9042 10.0333 12 9.75 12ZM5.75 12C5.46667 12 5.22917 11.9042 5.0375 11.7125C4.84583 11.5208 4.75 11.2833 4.75 11C4.75 10.7167 4.84583 10.4792 5.0375 10.2875C5.22917 10.0958 5.46667 10 5.75 10C6.03333 10 6.27083 10.0958 6.4625 10.2875C6.65417 10.4792 6.75 10.7167 6.75 11C6.75 11.2833 6.65417 11.5208 6.4625 11.7125C6.27083 11.9042 6.03333 12 5.75 12ZM13.75 12C13.4667 12 13.2292 11.9042 13.0375 11.7125C12.8458 11.5208 12.75 11.2833 12.75 11C12.75 10.7167 12.8458 10.4792 13.0375 10.2875C13.2292 10.0958 13.4667 10 13.75 10C14.0333 10 14.2708 10.0958 14.4625 10.2875C14.6542 10.4792 14.75 10.7167 14.75 11C14.75 11.2833 14.6542 11.5208 14.4625 11.7125C14.2708 11.9042 14.0333 12 13.75 12ZM9.75 16C9.46667 16 9.22917 15.9042 9.0375 15.7125C8.84583 15.5208 8.75 15.2833 8.75 15C8.75 14.7167 8.84583 14.4792 9.0375 14.2875C9.22917 14.0958 9.46667 14 9.75 14C10.0333 14 10.2708 14.0958 10.4625 14.2875C10.6542 14.4792 10.75 14.7167 10.75 15C10.75 15.2833 10.6542 15.5208 10.4625 15.7125C10.2708 15.9042 10.0333 16 9.75 16ZM5.75 16C5.46667 16 5.22917 15.9042 5.0375 15.7125C4.84583 15.5208 4.75 15.2833 4.75 15C4.75 14.7167 4.84583 14.4792 5.0375 14.2875C5.22917 14.0958 5.46667 14 5.75 14C6.03333 14 6.27083 14.0958 6.4625 14.2875C6.65417 14.4792 6.75 14.7167 6.75 15C6.75 15.2833 6.65417 15.5208 6.4625 15.7125C6.27083 15.9042 6.03333 16 5.75 16ZM13.75 16C13.4667 16 13.2292 15.9042 13.0375 15.7125C12.8458 15.5208 12.75 15.2833 12.75 15C12.75 14.7167 12.8458 14.4792 13.0375 14.2875C13.2292 14.0958 13.4667 14 13.75 14C14.0333 14 14.2708 14.0958 14.4625 14.2875C14.6542 14.4792 14.75 14.7167 14.75 15C14.75 15.2833 14.6542 15.5208 14.4625 15.7125C14.2708 15.9042 14.0333 16 13.75 16ZM2.25 20C1.85 20 1.5 19.85 1.2 19.55C0.9 19.25 0.75 18.9 0.75 18.5V3C0.75 2.6 0.9 2.25 1.2 1.95C1.5 1.65 1.85 1.5 2.25 1.5H3.875V0H5.5V1.5H14V0H15.625V1.5H17.25C17.65 1.5 18 1.65 18.3 1.95C18.6 2.25 18.75 2.6 18.75 3V18.5C18.75 18.9 18.6 19.25 18.3 19.55C18 19.85 17.65 20 17.25 20H2.25ZM2.25 18.5H17.25V7.75H2.25V18.5ZM2.25 6.25H17.25V3H2.25V6.25ZM2.25 6.25V3V6.25Z" fill="white"/>
                            </svg>
                        </span>
                        <Datepicker :upperLimit="new Date()" v-model="form.packaged_on" class="bg-theme-modalbg border-0 w-full h-9 rounded" placeholder="Select a Date" />
                        <span class="absolute top-4 right-4">
                            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.75 7.37578L0.75 1.37578L1.825 0.300781L6.75 5.25078L11.675 0.325781L12.75 1.40078L6.75 7.37578Z" fill="white"/>
                            </svg>
                        </span>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </div>
                </Field>
            </div>
        </div>
        <div class="w-full xl:w-1/3">
            <div class="input-wrapper">
                <Field type="checkbox" v-slot="{field}" name="badge_running" v-model="form.badge_running" :value="true" :unchecked-value="false">
                    <span class="text-white text-xs font-normal"> Currently Selling </span>
                    <div class="h-14">
                        <label for="badge-running" class="flex items-center cursor-pointer pt-2  w-[55px]">
                            <input v-bind="field" :value="true" type="checkbox" id="badge-running" class="hidden peer">
                            <div class="w-12 h-6 bg-gray-400 peer-focus:outline-none peer-focus:ring-4 
                            peer-focus:ring-theme-green dark:peer-focus:ring-theme-green relative rounded-full peer 
                            dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] 
                            after:absolute  after:bg-white after:border-gray-400 after:border after:rounded-full 
                            after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-theme-green"></div>
                        </label>
                        <div class="text-xs">&nbsp;</div>
                    </div>
                </Field>
            </div>
        </div>
        </div>
        <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
            <div class="w-full xl:w-1/3"  v-if="vg_selectedLocation.id">
                <div class="input-wrapper relative" :class="(variantForm && variantForm.thc_cbd_value_type=='single')?'':'hidden'">
                    <Field v-slot="{field, errors, errorMessage}" name="thc" v-model.number="form.thc">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">THC</label>
                        <div v-if="productForm.complianceType && productForm.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                        <div v-else class="flex flex-row rounded bg-gray-black ">
                            <span class="mt-1 ml-2">{{productForm.concentration_unit}}</span>
                            <input v-model.number="form.thc" placeholder="20.5" class="block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                        </div>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
                <!-- hide range for now -->
                <div :class="(variantForm && variantForm.thc_cbd_value_type=='range')?'':'hidden'">
                    <div class="input-wrapper">
                        <label class="text-xs">THC ({{productForm.concentration_unit}})</label>
                        <div class="flex">
                            <div class="relative w-full">
                                <Field v-slot="{field, errors, errorMessage}" name="thc_min" v-model.number="form.thc_min">
                                    <div v-if="productForm.complianceType && productForm.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                    <input v-else v-model.number="form.thc_min" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                    <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                    <div v-else class="text-xs">&nbsp;</div>
                                </Field>
                            </div>
                            <span class="mt-4 mx-1">
                                <svg width="5" height="3" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.61719 0.955078V2.5H0.754883V0.955078H4.61719Z" fill="white"/>
                                </svg>
                            </span>
                            <div class="relative w-full">
                                <Field v-slot="{field, errors, errorMessage}" name="thc_max" v-model.number="form.thc_max">
                                    <div v-if="productForm.complianceType && productForm.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                    <input v-else v-model.number="form.thc_max" placeholder="20.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                    <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                    <div v-else class="text-xs">&nbsp;</div>
                                </Field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full xl:w-1/3" v-if="vg_selectedLocation.id">
                <div class="input-wrapper relative" :class="(variantForm && variantForm.thc_cbd_value_type=='single')?'':'hidden'">
                    <Field v-slot="{field, errors, errorMessage}" name="cbd" v-model.number="form.cbd">
                        <label class="text-xs" :class="labelClass(field.value, errorMessage)">CBD</label>
                        <div v-if="productForm.complianceType && productForm.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                        <div v-else class="flex flex-row rounded bg-gray-black ">
                            <span class="mt-1 ml-2">{{productForm.concentration_unit}}</span>
                            <input v-model.number="form.cbd" placeholder="2.5" class="block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                        </div>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
                <!-- hide range for now -->
                <div :class="(variantForm && variantForm.thc_cbd_value_type=='range')?'':'hidden'">
                    <div class="input-wrapper">
                        <label class="text-xs">CBD ({{productForm.concentration_unit}})</label>
                        <div class="flex">
                            <div class="relative w-full">
                                <Field v-slot="{field, errors, errorMessage}" name="cbd_min" v-model.number="form.cbd_min">
                                    <div v-if="productForm.complianceType && productForm.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                    <input v-else v-model.number="form.cbd_min" placeholder="2.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                    <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                    <div v-else class="text-xs">&nbsp;</div>
                                </Field>
                            </div>
                            <span class="my-4 mx-1">
                                <svg width="5" height="3" viewBox="0 0 5 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.61719 0.955078V2.5H0.754883V0.955078H4.61719Z" fill="white"/>
                                </svg>
                            </span>
                            <div class="relative w-full">
                                <Field v-slot="{field, errors, errorMessage}" name="cbd_max" v-model.number="form.cbd_max">
                                    <div v-if="productForm.complianceType && productForm.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                                    <input v-else v-model.number="form.cbd_max" placeholder="2.5" class="px-1 block tracking-wider border-0 focus:ring-0 bg-gray-black  w-full text-sm placeholder-theme-878686" type="number">
                                    <div v-if="errors.length>0" class="text-xs" :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                                    <div v-else class="text-xs">&nbsp;</div>
                                </Field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full xl:w-1/4">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="totalTerp" v-model.number="form.totalTerp">
                        <label class="text-xs">Terps</label>
                        <div v-if="productForm.complianceType && productForm.complianceType?.toLowerCase() === 'accessory'" class="capitalize block rounded border-none bg-gray-black w-full text-sm tracking-wider text-theme-878686 p-2 h-[36px]">N/A</div>
                        <div v-else class="flex flex-row rounded bg-gray-black ">
                            <span class="mt-1 ml-2">%</span>
                            <input v-model="form.totalTerp" placeholder="24" min="0" class="block tracking-wider border-none focus:ring-0 rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="number">
                        </div>
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
            <div class="w-full xl:w-1/3">
                <div class="input-wrapper relative">
                    <Field v-slot="{field, errors, errorMessage}" name="lot_cost" v-model.number="form.lot_cost">
                        <label class="text-xs">Cost</label>
                        <input @wheel.prevent v-model.number="form.lot_cost" placeholder=" 24" class="block tracking-wider border-none rounded bg-gray-black w-full text-sm placeholder-theme-878686" type="number">
                        <div v-if="errors.length>0" class="text-xs"  :class="errorClass(field.value, errorMessage)">{{ errorMessage }}</div>
                        <div v-else class="text-xs">&nbsp;</div>
                    </Field>
                </div>
            </div>
        </div>
        
        <div class="flex justify-center">
            <button class="rounded bg-theme-green hover:bg-theme-green-300 px-28 py-3 text-sm tracking-wider font-medium">{{asn?'SAVE':'CONFIRM'}}</button>
        </div>
    </Form>
</template>
<script>
import Datepicker from 'vue3-datepicker'
import {ref, defineComponent } from 'vue'
import {Form, Field} from 'vee-validate'
import {mapGetters} from 'vuex'
import ObjectHelper from '@/helpers/object'

export default defineComponent({
    props: ['asn', 'defaults', 'productForm', 'variantForm'],
    components: {
        Datepicker,
        Form,
        Field
    },
    setup() {
        const form = ref({
            thc: '',
            thc_min: '',
            thc_max: '',
            cbd: '',
            cbd_min: '',
            cbd_max: '',
            batch_lot: '',
            badge_running: true,
            packaged_on: '',
            current_nou: '',
            lot_cost: '',
            totalTerp: ''
        })
        const accessorySchema = {
            thc: 'price',
            thc_min: 'price',
            thc_max: 'price',
            cbd: 'price',
            cbd_min: 'price',
            cbd_max: 'price',
            batch_lot: '',
            badge_running: '',
            packaged_on: 'requiredDateIf:batch_lot',
            lot_cost: '',
            totalTerp: 'percentage'
        }
        const singleSchema = {
            thc: 'price|requiredDateIf:batch_lot',
            thc_min: 'price',
            thc_max: 'price',
            cbd: 'price|requiredDateIf:batch_lot',
            cbd_min: 'price',
            cbd_max: 'price',
            batch_lot: '',
            badge_running: '',
            packaged_on: 'requiredDateIf:batch_lot',
            lot_cost: '',
            totalTerp: 'percentage'
        }
        const rangeSchema = {
            thc: 'price',
            thc_min: 'price|requiredDateIf:batch_lot',
            thc_max: 'price|requiredDateIf:batch_lot',
            cbd: 'price',
            cbd_min: 'price|requiredDateIf:batch_lot',
            cbd_max: 'price|requiredDateIf:batch_lot',
            batch_lot: '',
            badge_running: '',
            packaged_on: 'requiredDateIf:batch_lot',
            lot_cost: '',
            totalTerp: 'percentage'
        }
        return {form, accessorySchema, singleSchema, rangeSchema}
    },
    computed: {
        ...mapGetters({
            vg_selectedBusiness: 'auth/activeBusiness',
            vg_selectedLocation: 'location/selected'
        })
    },
    watch: {
        defaults(value){
            this.form = ObjectHelper.pickWithDefault(
                value, ['thc', 'thc_min', 'thc_max', 'cbd', 'cbd_min', 'cbd_max', 'batch_lot', 'badge_running', 'packaged_on', 'current_nou', 'lot_cost', 'totalTerp'],
                ['', '', '', '', '', '', '', true, '', 0, '', ''])
            this.form.current_nou = value.current_nou?value.current_nou:0
        }
    },
    methods: {
        getSchema(){
            if(this.vg_selectedLocation.id){
                if(this.productForm.complianceType?.toLowerCase()=='accessory'){
                    return this.accessorySchema
                }else{
                    if(this.variantForm.thc_cbd_value_type=='single'){
                        return this.singleSchema
                    }else{
                        return this.rangeSchema
                    }
                }
            }else{
                return ''
            }
        },
        labelClass(value, error){
            if(value && error){
                return 'text-theme-red'
            }else if(error){
                return 'text-theme-orange'
            }else if(value){
                return 'text-theme-green'
            }
        },
        inputClass(value, error){
            if(value && error){
                return 'border-theme-red'
            }else if(error){
                return 'border-theme-orange'
            }else if(value){
                return 'border-theme-green'
            }
        },
        errorClass(value, error){
            if(value && error){
                return 'text-theme-red'
            }else if(error){
                return 'text-theme-orange'
            }
        },
        submit(){
            this.$emit('validated', this.form)
        }
    }
})
</script>
<style>
.v3dp__datepicker{
    display: flex;
    flex-direction: row;
}
</style>
